export const STEPS = [
  'Project Details',
  'Checklist Details',
  'Submission',
  'Review and Submit',
];
